/**
 * Amberden — the phone menu (snippets/amberden-menu.liquid).
 *
 * showModal() already contains focus and closes on Escape. This adds the rest
 * of Direction A's specification: the navigation rises 12px over 220ms on open
 * and drops 8px over 120ms on close; nothing moves under prefers-reduced-motion;
 * aria-expanded on the Menu button; the page behind does not scroll; and focus
 * returns to Menu when the dialog closes.
 *
 * Search and Bag inside the menu hand over to their own overlays (the search
 * modal and the cart drawer, via amberden-search.js and amberden-bag.js). This
 * closes the menu first, in the capture phase, so the next overlay does not
 * open underneath a menu that is still on screen.
 */
(function () {
  var dialog = document.getElementById('amb-menu');
  var opener = document.querySelector('[data-amb-menu-open]');
  if (!dialog || !opener || typeof dialog.showModal !== 'function') return;

  var nav = dialog.querySelector('.amb-menu__nav');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var closing = false;

  function open() {
    if (dialog.open) return;
    // Line the menu's top row up with the bar it covers. On product pages the bar
    // sits under the announcement strip; once scrolled away it is clamped to 0.
    var bar = document.querySelector('.amb-phone__bar');
    var top = bar ? Math.max(0, Math.round(bar.getBoundingClientRect().top)) : 0;
    dialog.style.setProperty('--amb-bar-top', top + 'px');
    document.documentElement.classList.add('amb-menu-open');
    dialog.showModal();
    opener.setAttribute('aria-expanded', 'true');
    if (!reduced.matches && nav) {
      nav.animate(
        [{ transform: 'translateY(12px)' }, { transform: 'translateY(0)' }],
        { duration: 220, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
    }
  }

  function finish() {
    if (dialog.open) dialog.close();
    closing = false;
  }

  function close(immediate) {
    if (!dialog.open) { closing = false; return; }
    if (closing && !immediate) return;
    if (immediate || reduced.matches || !nav) { finish(); return; }
    closing = true;
    var done = false;
    var end = function () { if (!done) { done = true; finish(); } };
    try {
      nav.animate(
        [{ transform: 'translateY(0)' }, { transform: 'translateY(8px)' }],
        { duration: 120, easing: 'cubic-bezier(0.4, 0, 1, 1)' }
      ).finished.then(end, end);
    } catch (err) { end(); }
    // Browsers pause animations in background tabs and power-saving modes, and a
    // paused animation never finishes. Close regardless, so the menu can never be
    // left open with Escape and Close both ignored.
    setTimeout(end, 220);
  }

  // Whatever closed it (Close, Escape, a link, a handover), tidy up once.
  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('amb-menu-open');
    opener.setAttribute('aria-expanded', 'false');
    opener.focus({ preventScroll: true });
  });

  // Escape: let the motion run instead of the native instant close.
  dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(false); });
  // And an explicit handler, so Escape does not depend on the browser's dialog
  // close-watcher firing (it does not for synthetic key events, and close-watcher
  // rules differ between engines).
  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !e.defaultPrevented) { e.preventDefault(); close(false); }
  });

  opener.addEventListener('click', open);
  dialog.querySelector('[data-amb-menu-close]').addEventListener('click', function () { close(false); });

  // Search and Bag open their own overlay: shut the menu before they do.
  document.addEventListener('click', function (e) {
    if (!dialog.open) return;
    var t = e.target && e.target.closest ? e.target.closest('[data-amb-search], [data-amb-bag]') : null;
    if (t && dialog.contains(t)) close(true);
  }, true);

  // Leaving the phone width with the menu open would strand an invisible dialog.
  window.matchMedia('(min-width: 900px)').addEventListener('change', function (mq) {
    if (mq.matches) close(true);
  });
})();
